(function () {
  'use strict';
  if (customElements.get('aestra-fit-finder')) return;
  const E = window.AestraFitEngine;
  class FitFinder extends HTMLElement {
    connectedCallback() {
      if (this.ready || !E) return;
      this.ready = true;
      try { this.data = JSON.parse(this.querySelector('[data-ff-data]').textContent); } catch (_) { return; }
      if (!this.data.config && this.data.catalog) {
        try { this.data.config = JSON.parse(this.data.catalog)[this.data.handle] || null; } catch (_) { this.data.config = null; }
      }
      this.options = [...this.data.options];
      this.dialog = this.querySelector('dialog');
      if (!this.dialog.showModal) return;
      this.form = this.querySelector('form');
      this.heightOnly = this.data.config?.mode === 'height-only';
      if (this.heightOnly) {
        ['weight', 'waist'].forEach(name => {
          const field = this.form.elements[name];
          field.disabled = true;
          field.closest('label').hidden = true;
        });
        this.form.querySelector('fieldset').hidden = true;
        this.form.querySelector('[id^="ff-waist-"]').hidden = true;
      }
      this.compare = this.querySelector('[data-ff-compare]');
      this.select = this.querySelector('[data-ff-select]');
      this.trigger = this.querySelector('[data-ff-open]');
      this.trigger.hidden = false;
      this.missing = E.validate(this.data.config, this.data.handle, this.data.sizes);
      this.form.querySelector('[type=submit]').disabled = this.missing.length > 0;
      if (this.missing.length) {
        const notice = document.createElement('p');
        notice.className = 'ff-muted';
        notice.textContent = 'Personal recommendations are not available yet. Compare the garment measurements and available sizes below.';
        this.form.prepend(notice);
      }
      this.trigger.addEventListener('click', () => {
        this.oldOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
        this.update();
        this.form.elements.height.focus();
      });
      this.querySelector('[data-ff-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', e => { if (e.target === this.dialog) this.dialog.close(); });
      this.dialog.addEventListener('keydown', e => { if (e.key === 'Escape') e.stopPropagation(); });
      this.dialog.addEventListener('close', () => { document.body.style.overflow = this.oldOverflow || ''; this.trigger.focus(); });
      this.form.addEventListener('input', () => {
        this.result = null; this.lastInput = null;
        this.querySelector('.ff-error').textContent = '';
        this.form.querySelectorAll('input').forEach(i => i.removeAttribute('aria-invalid'));
        this.update();
      });
      this.form.addEventListener('submit', e => {
        e.preventDefault();
        const input = { fit: this.form.elements.fit.value };
        let invalid;
        (this.heightOnly ? ['height'] : ['height', 'weight', 'waist']).forEach(key => {
          const field = this.form.elements[key];
          const value = field.value.trim();
          input[key] = key === 'waist' && !value && !field.validity.badInput ? null : Number(value);
          const bad = field.validity.badInput || (input[key] !== null && (!value || !Number.isFinite(input[key]) || input[key] <= 0));
          field.setAttribute('aria-invalid', String(bad));
          if (bad && !invalid) invalid = field;
        });
        if (invalid) {
          this.querySelector('.ff-error').textContent = this.heightOnly ? 'Enter your height as a positive number in cm.' : 'Enter positive numbers in cm and kg. You can leave body waist blank.';
          invalid.focus(); return;
        }
        this.lastInput = input;
        this.result = E.recommend(this.data.config, this.data.handle, this.data.sizes, input, s => this.inStock(s));
        if (this.result.selected) this.compare.value = this.result.selected.row.label;
        this.update();
      });
      this.compare.addEventListener('change', () => this.renderSize());
      this.select.addEventListener('click', () => {
        if (!this.inStock(this.compare.value)) { this.update(); return; }
        const detail = { size: this.compare.value, optionIndex: this.data.sizeIndex, accepted: false };
        document.dispatchEvent(new CustomEvent('aestra:select-size', { detail }));
        if (detail.accepted) this.dialog.close();
        else this.querySelector('[data-ff-context]').textContent = 'That combination is unavailable. Choose another size or update your product options.';
      });
      this.onVariant = e => {
        this.options = [...e.detail.options];
        if (this.lastInput) this.result = E.recommend(this.data.config, this.data.handle, this.data.sizes, this.lastInput, s => this.inStock(s));
        this.update();
      };
      document.addEventListener('aestra:variant-change', this.onVariant);
      this.update();
    }
    disconnectedCallback() { document.removeEventListener('aestra:variant-change', this.onVariant); }
    inStock(size) { return E.available(this.data, this.options, size); }
    update() {
      const previous = this.compare.value || this.options[this.data.sizeIndex];
      this.compare.replaceChildren();
      this.data.sizes.forEach(size => {
        const option = document.createElement('option');
        option.value = size;
        option.textContent = size + (this.inStock(size) ? '' : ' — unavailable');
        this.compare.append(option);
      });
      this.compare.value = this.data.sizes.includes(previous) ? previous : this.data.sizes[0];
      const status = this.querySelector('[data-ff-status]');
      status.replaceChildren();
      const heading = document.createElement('h3');
      const description = document.createElement('p');
      const r = this.result;
      if (this.missing.length) {
        const measured = this.data.config && Array.isArray(this.data.config.sizes) && this.data.config.sizes.some(s => E.measurements(s, this.data.config.category));
        heading.textContent = 'Fit recommendations coming soon';
        description.textContent = measured ? 'Garment measurements are ready. We’re still verifying weight, body-waist and preferred-fit guidance. Compare the measurements and brand height guide, then choose a size yourself.' : 'We’re confirming this product’s measurements and fit examples. Recommendations are not available yet. You can still compare stock and choose a size yourself.';
      } else if (!r) {
        heading.textContent = 'Find your starting point';
        description.textContent = this.heightOnly ? 'Enter your height for a suggestion from AESTRA’s height guide. This estimate does not assess weight, waist, preferred fit or where the hem will sit. Compare garment measurements before choosing.' : 'Enter your measurements to check the verified fit ranges for this product. Adding body waist helps narrow the estimate.';
      } else if (r.heightOnly) {
        heading.textContent = r.status === 'match' ? `Height-only suggestion: ${r.selected.row.label}` : r.status === 'unavailable' ? `Suggested size ${r.matches.map(m => m.row.label).join(', ')} is unavailable` : 'No height-guide match';
        description.textContent = r.status === 'no-match' ? 'Your height falls outside the supplied height bands. We won’t guess a size; compare measurements or contact us.' : 'Based only on AESTRA’s height guide—not a full fit assessment. Waist, weight, preferred fit and hem position have not been assessed. Check garment measurements before choosing.';
        if (r.status === 'unavailable') description.textContent += ' We won’t substitute an available size outside your height band.';
      } else if (r.status === 'match') {
        heading.textContent = `Estimated size: ${r.selected.row.label}`;
        description.textContent = `Your ${r.waistProvided ? 'height, weight and body waist' : 'height and weight'} fall within this product’s verified ${this.lastInput.fit.replace('-', ' ')} fit range for this garment length. ${r.waistProvided ? 'Body proportions can still change the fit.' : 'Waist fit has not been checked; add your body waist for a better estimate.'}`;
        if (r.alternative) description.textContent += ` Adjacent alternative: ${r.alternative.row.label}, also within the verified range and in stock.`;
        if (r.matches.filter(m => m.available).length > 1) description.textContent += ` Where ranges overlap, ${this.lastInput.fit === 'extra-baggy' ? 'the larger' : 'the smaller'} suitable size is shown first.`;
      } else if (r.status === 'unavailable') {
        heading.textContent = 'Suitable sizes are unavailable';
        description.textContent = `Matching sizes (${r.matches.map(m => m.row.label).join(', ')}) are unavailable for your selected options. We can’t recommend another available size from the verified data.`;
      } else {
        heading.textContent = 'No verified match';
        description.textContent = 'Your measurements or preferred fit fall outside this product’s verified ranges. We can’t recommend a suitable available size. Check the size guide or contact us for help.';
      }
      status.append(heading, description);
      this.renderSize();
    }
    renderSize() {
      const label = this.compare.value;
      const c = this.data.config;
      const row = c && c.product_handle === this.data.handle && Array.isArray(c.sizes) && c.sizes.find(s => s && s.label === label);
      const measured = E.measurements(row, c && c.category);
      const dl = this.querySelector('[data-ff-measurements]');
      dl.replaceChildren();
      const add = (name, value) => { const dt = document.createElement('dt'), dd = document.createElement('dd'); dt.textContent = name; dd.textContent = value; dl.append(dt, dd); };
      if (measured) {
        const g = row.garment;
        add(`Garment waist (${g.waist_basis}, relaxed → stretched)`, `${g.waist_relaxed_cm} → ${g.waist_stretched_cm} cm`);
        add(`Garment ${g.length_basis}`, `${g.length_cm} cm`);
        if (g.inseam_cm) add('Garment inseam', `${g.inseam_cm} cm`);
        if (c.category === 'pants') add('Garment hem width (one leg, flat)', `${g.hem_flat_cm} cm`);
        if (Array.isArray(row.brand_height_cm)) add('Brand height guide (not a full fit assessment)', `${row.brand_height_cm[0]}–${row.brand_height_cm[1]} cm`);
        if (row.note) add('Measurement note', row.note);
      }
      const match = this.result && this.result.matches && this.result.matches.find(m => m.row.label === label);
      const hems = match ? [...new Set(match.profiles.map(p => p.hem).filter(Boolean))] : [];
      const hem = hems.length === 1 ? hems[0] : null;
      const context = this.querySelector('[data-ff-context]');
      context.textContent = !measured ? 'Verified garment measurements are not available for this size.' : match && this.heightOnly ? 'Matches the brand height guide only. Waist fit and hem position are not estimated.' : match ? `This size falls within the verified range. ${hem ? `Estimated hem: ${hem.replace(/-/g, ' ')}.` : 'Hem position cannot be estimated from the available evidence.'}` : 'Manual comparison only. This size has not been matched to your measurements.';
      this.select.disabled = !this.inStock(label);
      this.select.textContent = this.inStock(label) ? `SELECT ${label}` : `${label} — UNAVAILABLE`;
      const preview = this.querySelector('[data-ff-preview]');
      if ((c && c.category === 'other') || (!c && !this.data.isPants)) {
        preview.textContent = 'Compare the garment measurements above. A fit illustration is not configured for this product.';
        return;
      }
      const rows = c && Array.isArray(c.sizes) ? c.sizes.filter(s => E.measurements(s, 'pants')) : [];
      const widest = Math.max(...rows.map(s => s.garment.hem_flat_cm), 1);
      const longest = Math.max(...rows.map(s => s.garment.length_cm), 1);
      const width = measured ? row.garment.hem_flat_cm / widest * 53 : 48;
      const length = measured ? row.garment.length_cm / longest * 190 : 190;
      const bottom = hem === 'above-shoe' ? 260 : hem === 'stacked' ? 302 : hem === 'on-shoe' ? 291 : 279;
      const top = bottom - length;
      // Schematic garment proportions only. No body, camo texture or logo is generated.
      preview.innerHTML = `<svg viewBox="0 0 300 330" role="img" aria-label="Illustrative wide-leg pants schematic. Hem position ${hem ? hem.replace(/-/g, ' ') : 'not estimated'}."><path d="M59 291 Q49 306 48 310 H126 L129 291 M174 291 L171 310 H252 Q248 300 234 291" fill="#ddd" stroke="#777"/><path d="M82 ${top} H218 L${205 + width / 2} ${bottom} H${205 - width / 2} L150 ${top + 58} L${95 + width / 2} ${bottom} H${95 - width / 2} Z" fill="#202020" stroke="#eee" stroke-width="1.5"/><path d="M82 ${top + 12} H218 M150 ${top + 12} V${top + 58}" fill="none" stroke="#777"/><path d="M${95 - width / 2} ${bottom - 9} H${95 + width / 2} M${205 - width / 2} ${bottom - 9} H${205 + width / 2}" stroke="#777"/>${hem === 'stacked' ? `<path d="M${95 - width / 2} 279 l${width} 6 M${205 - width / 2} 279 l${width} 6" stroke="#777"/>` : ''}<text x="150" y="24" fill="#aaa" text-anchor="middle" font-size="10" letter-spacing="2">ILLUSTRATIVE / NOT TO SCALE</text></svg>`;
    }
  }
  customElements.define('aestra-fit-finder', FitFinder);
})();
